
/* oxlint-disable */
import React from "react";

import type {_Types} from "./index"

type TContext = _Types["Context"];

type TMutableContext = TContext & {
    setValue: React.Dispatch<React.SetStateAction<TContext>>;
};

export const Context = React.createContext<TMutableContext>(null!);
